import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useMergeClasses, useTheme } from '../../../../../../theme';
import Money from '../../../../../../Money';
import { SafeHtml } from '../../../SafeHtml';
const CardExtraView = ({ className, classes, type, selected, icon, title, badge, description, content, styles, minPrice, totalPrice, headerControls, additionalControls, footerControls, onClick }) => {
    const { t } = useTranslation('CardExtra');
    const { CardExtraView: defaultClasses } = useTheme('Shared').CardExtraView;
    const theme = useMergeClasses(defaultClasses, classes);
    const descriptionContent = description && typeof description === 'string' ? (React.createElement(SafeHtml, { className: theme.description, html: description })) : (React.createElement("div", { className: theme.description }, description));
    const existTotalPrice = !!totalPrice && totalPrice.amount !== undefined;
    const showContent = !!content || !!descriptionContent;
    const showPrice = !!totalPrice || !!minPrice;
    const showFooter = showPrice || !!footerControls;
    return (React.createElement("div", { className: cn(theme.root, {
            [theme.root_selected]: selected,
            [theme.root_clickable]: !!onClick,
            [theme.root_seats]: type === 'seats',
            [theme.root_baggage]: type === 'baggage',
            [theme.root_baggageDelivery]: type === 'baggage-delivery',
            [theme.root_animal]: type === 'animal',
            [theme.root_meal]: type === 'meal',
            [theme.root_businessLounge]: type === 'business-lounge',
            [theme.root_priorityBoarding]: type === 'priority-boarding',
            [theme.root_insurance]: type === 'insurance',
            [theme.root_transfer]: type === 'transfer',
            [theme.root_capsuleHotel]: type === 'capsule-hotel',
            [theme.root_loyalty]: type === 'loyalty',
            [theme.root_upgrade]: type === 'upgrade',
            [theme.root_sms]: type === 'sms',
            [theme.root_refundableTicket]: type === 'refundable-ticket',
            [theme.root_misc]: type === 'misc'
        }, className), style: { order: styles === null || styles === void 0 ? void 0 : styles.order }, "data-service-type": type, onClick: onClick },
        React.createElement("div", { className: theme.header, style: { background: styles === null || styles === void 0 ? void 0 : styles.background } },
            title && React.createElement("div", { className: theme.header__title }, title),
            icon && React.createElement("div", { className: theme.header__icon }, icon),
            badge && React.createElement("div", { className: theme.header__badge }, badge),
            headerControls),
        showContent && React.createElement("div", { className: theme.content }, content !== null && content !== void 0 ? content : descriptionContent),
        additionalControls && React.createElement("div", { className: theme.controls }, additionalControls),
        showFooter && (React.createElement("div", { className: theme.footer },
            showPrice && (React.createElement("span", { className: theme.footer__price },
                t(existTotalPrice ? 'total' : 'from'),
                existTotalPrice ? ':' : '',
                React.createElement(Money, { money: existTotalPrice ? totalPrice : minPrice }))),
            footerControls))));
};
export default CardExtraView;
